import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=f2e29a74&"
import script from "./AddressForm.vue?vue&type=script&lang=ts&"
export * from "./AddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports